export default "__VITE_ASSET__df9199e4__"